function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 74.388l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 88.247l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 102.106l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 115.966l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 129.825l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 143.685l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 157.544l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 171.403l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 185.263l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 199.122l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 212.981l-96-73.759-96 73.76-96-73.76-96 73.76"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 226.84l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 240.7l-96-73.759-96 73.758-96-73.758-96 73.758"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 254.559l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 268.418l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 282.277l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 296.137l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 309.996l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 323.855l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 337.715l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 351.574l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 365.434l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 379.293l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 393.152l-96-73.759-96 73.76-96-73.76-96 73.76"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 407.01l-96-73.757-96 73.758-96-73.758-96 73.758"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.305 420.87l-96-73.758-96 73.758-96-73.758-96 73.758"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 385 422"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default __webpack_public_path__ + "static/media/parallel-lines-2.e2bff944.svg";
export { SvgComponent as ReactComponent };